<template>
  <!-- Error page-->
  <div class="misc-wrapper">
       <!-- Brand logo-->
      <b-link class="brand-logo" :to="{name:'welcome'}">
         <img :src="logo_fondo_claro" alt="Logo" />
      </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
         {{ $t('Página no encontrada') }} 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          {{ $t('¡UPS!') }} 😖 {{ $t('La URL solicitada no se encontró en este servidor') }}
        </p>

        <b-button variant="primary" class="mb-2 btn-sm-block" :to="{name:'home'}">
          {{ $t('Regresar a home') }}
        </b-button>

        <b-img
          fluid
          :src="imgUrl"
          alt="Error Page"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import errorSvg from '@/assets/images/pages/error.svg'
import errorDarkSvg  from '@/assets/images/pages/error-dark.svg';
import logo_fondo_claro from 'images/logos/logo_fondo_claro.svg'



import useAppConfigStore from '@/store/app-config';

const app_config_store = useAppConfigStore();

const downImg = errorSvg;

const {layout} = storeToRefs(app_config_store);

const imgUrl = computed(() => layout.value.skin === 'dark' ? errorDarkSvg : errorSvg);
const skin = computed(() => layout.value.skin)

</script>

<style lang="scss">
@import '@/assets/scss/vue/pages/page-misc.scss';
</style>
